import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
export function useSocket(channelId) {
    const socketRef = useRef(null);
    const [isConnected, setIsConnected] = useState(false);
    const currentChannelRef = useRef(undefined);
    useEffect(() => {
        // JWT is required server-side for join:channel and sandbox events.
        // auth as a callback is re-read on every reconnect (token refresh).
        const socket = io({ path: "/ws", auth: (cb) => cb({ token: localStorage.getItem("token") ?? "" }) });
        socketRef.current = socket;
        socket.on("connect", () => setIsConnected(true));
        socket.on("disconnect", () => setIsConnected(false));
        return () => {
            socket.disconnect();
        };
    }, []);
    // Join/leave channel rooms when channelId changes
    useEffect(() => {
        const socket = socketRef.current;
        if (!socket)
            return;
        if (currentChannelRef.current) {
            socket.emit("leave:channel", currentChannelRef.current);
        }
        if (channelId) {
            socket.emit("join:channel", channelId);
        }
        currentChannelRef.current = channelId;
    }, [channelId]);
    function on(event, handler) {
        socketRef.current?.on(event, handler);
        return () => {
            socketRef.current?.off(event, handler);
        };
    }
    function emit(event, data) {
        socketRef.current?.emit(event, data);
    }
    return { on, emit, isConnected };
}
